import { ComponentsOverrides, Theme } from "@mui/material";

type MuiInputBase = {
  styleOverrides: ComponentsOverrides<Theme>["MuiInputBase"];
};

const muiInputBase: MuiInputBase = {
  styleOverrides: {
    inputAdornedStart: {
      paddingLeft: "0px !important",
    },
  },
};

export default muiInputBase;
